import useLenis from "@/hooks/useLenis";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import TrustStrip from "@/components/site/TrustStrip";
import About from "@/components/site/About";
import Facilities from "@/components/site/Facilities";
import OccasionsMarquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import Stats from "@/components/site/Stats";
import Footprint from "@/components/site/Footprint";
import Portfolio from "@/components/site/Portfolio";
import Testimonials from "@/components/site/Testimonials";
import Inquiry from "@/components/site/Inquiry";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import WhatsAppFloat from "@/components/site/WhatsAppFloat";
import ReviewPopup from "@/components/site/ReviewPopup";

export default function Home() {
  useLenis();
  return (
    <div data-testid="home-page" className="bg-heirloom-bone overflow-x-hidden">
      <Nav />
      <Hero />
      <TrustStrip />
      <About />
      <Facilities />
      <OccasionsMarquee />
      <Services />
      <WhyChooseUs />
      <Stats />
      <Footprint />
      <Portfolio />
      <Testimonials />
      <Inquiry />
      <Contact />
      <Footer />
      <WhatsAppFloat />
      <ReviewPopup />
    </div>
  );
}
